import { render, staticRenderFns } from "./ConversationWrap.vue?vue&type=template&id=dd2501de&scoped=true&"
import script from "./ConversationWrap.vue?vue&type=script&lang=js&"
export * from "./ConversationWrap.vue?vue&type=script&lang=js&"
import style0 from "./ConversationWrap.vue?vue&type=style&index=0&id=dd2501de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2501de",
  null
  
)

export default component.exports